import React, {FC} from 'react';

import {Box, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';

import CloseOutlinedIcon from 'assets/icons/closedOutlinedIcon';
import Button from 'components/button/Button';
import {useAppSelector} from 'hooks';
import SendBrowserEvent from 'services/send-browser-event';
import {setVariantIdsOfItemThatWasAdjustedQuantityAction} from 'store/actions/basket-action';
import {getHMMHour} from 'utils';
import {StyledDialog} from 'views/address-drawer/styles';

import ExpressPicture from '../../assets/images/out-of-express-working-hours.png';

export interface ExpressOutOfWorkingHoursModalProps {
  open: boolean;
  onClose: () => void;
}

export const ExpressOutOfWorkingHoursModal: FC<ExpressOutOfWorkingHoursModalProps> = ({open, onClose}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {basket} = useAppSelector((state) => state.basket);

  const {from, to} = basket?.storeInfo?.[0].expressDeliveryTimeFrame || {};
  const formattedFrom = getHMMHour(from as number);
  const formattedTo = getHMMHour(to as number);

  const onBackToHome = () => {
    SendBrowserEvent.closeBasketDrawer();
    dispatch(setVariantIdsOfItemThatWasAdjustedQuantityAction([]));
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogTitle>
        <IconButton onClick={onClose}>
          <CloseOutlinedIcon color="secondary" fontSize="medium" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <Box component="img" width={160} height={160} src={ExpressPicture}></Box>
        </Box>
        <Typography textAlign="center" fontSize={20} fontWeight={700}>
          {t('express.title.expressIsClose')}
        </Typography>
        <Typography textAlign="center" fontSize={16} whiteSpace="pre-line">
          {t('express.message.weWillBeBackAt', {from: formattedFrom, to: formattedTo})}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button shape="rounded" variant="contained" fullWidth onClick={onBackToHome}>
          {t('express.label.backToHome')}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

ExpressOutOfWorkingHoursModal.displayName = 'ExpressOutOfWorkingHoursModal';
